import * as Sentry from '@sentry/browser';
import ReactDOM from 'react-dom/client';
import App from './Components/App';
import { AppProvider } from './Components/AppContext';
import './index.css';
Sentry.init({
  dsn: "https://c65da4d3fe024e0e883b825b40e22f7f@o424565.ingest.sentry.io/4505324735627264"
});
const root = ReactDOM.createRoot(
  document.getElementById('edullaChatRoot') as HTMLElement
);

root.render(
  <AppProvider>
    <App />
  </AppProvider>
);